module.exports = __webpack_public_path__ + "img/banner6.35fe15a6.jpg";